<template>
  <BranchOfficeSelect
    hint=" En esta sucursal va a estar radicada tu cuenta"
    label="Sucursal"
    name="sucursal"
    :value="value"
    :required="required"
    :subhint="subhint"
    :validationError="validationError"
    :quantumObfuscate="quantumObfuscate"
    :options="options"
    :titleFn="titleNew"
    :displayFn="displayNew"
    :zIndex="11"
    @input="$emit('input', $event)"
    @click="$emit('click')"
  >
    <template #option="{ option }">
      {{ option.direccion }}
      <span class="secondary">- ({{ option.distancia }})</span>
      <br />
      <span class="secondary">{{ option.localidad }}</span>
    </template>
  </BranchOfficeSelect>
</template>

<script>
import { mapGetters } from "vuex";
import BranchOfficeSelect from "@/components/core/composite/combos/BranchOfficeSelect";

export default {
  name: "BranchOffices",
  components: { BranchOfficeSelect },
  props: [
    "placeholder",
    "label",
    "value",
    "subhint",
    "validationError",
    "items",
    "inputMode",
    "quantumObfuscate",
    "required"
  ],
  data() {
    return {
      tieneCoordenadas: this.$store.getters.getTieneCoordenadas()
    };
  },
  computed: {
    ...mapGetters({ _sucursales: "getSucursales" }),
    options() {
      const data = this._sucursales && this._sucursales();
      if (!data) return [];
      return data.map(item => ({
        label: item.description || item,
        value: item.id || item,
        provincia: item.address.city || item,
        localidad: item.address.city || item,
        distancia: item.distance ? this.distanceParsed(item.distance) : item,
        direccion: item.address.addressName || item
      }));
    }
  },
  watch: {
    options: {
      immediate: true,
      handler(newVal) {
        if (this.tieneCoordenadas && newVal && newVal[0]) {
          this.$emit("input", newVal[0].value);
        }
      }
    }
  },
  methods: {
    titleNew(o) {
      return `${o.direccion} - (${o.distancia}) - ${o.localidad}`;
    },
    displayNew(o) {
      return `${o.value} - ${o.direccion} - ${o.localidad}`;
    },
    distanceParsed(distance) {
      const n = Number.parseInt(distance, 10);
      if (n > 1000) {
        const km = new Intl.NumberFormat("es-AR").format((n / 1000).toFixed(2));
        return `a ${km} km`;
      }
      return `a ${n} m`;
    }
  }
};
</script>

<style scoped>
.secondary {
  font-size: 0.8em;
}
</style>
